import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home as HomeIcon } from "lucide-react";
import { navMenu } from "../mock";

const PageShell = ({ title, subtitle, breadcrumbs = [], children, sidebar = true }) => {
  const location = useLocation();
  // Find current section
  const section = navMenu.find((m) => location.pathname.startsWith(m.slug));

  return (
    <div className="bg-white">
      {/* Banner */}
      <div
        className="relative"
        style={{
          background: "linear-gradient(120deg, #1c4d9c 0%, #2f6bc8 100%)",
        }}
      >
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(circle at 80% 30%, white 1.5px, transparent 1.5px)",
            backgroundSize: "40px 40px",
          }}
        />
        <div className="relative max-w-[1280px] mx-auto px-4 py-14">
          <div className="flex items-center gap-2 text-white/80 text-[13px] mb-4">
            <Link to="/" className="hover:text-white flex items-center gap-1">
              <HomeIcon className="w-3.5 h-3.5" /> Anasayfa
            </Link>
            {breadcrumbs.map((b, i) => (
              <React.Fragment key={i}>
                <ChevronRight className="w-3.5 h-3.5" />
                {b.link ? (
                  <Link to={b.link} className="hover:text-white">
                    {b.label}
                  </Link>
                ) : (
                  <span>{b.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white">{title}</h1>
          {subtitle && (
            <p className="text-white/85 mt-3 max-w-2xl">{subtitle}</p>
          )}
        </div>
      </div>

      {/* Content with sidebar */}
      <div className="max-w-[1280px] mx-auto px-4 py-12">
        <div className={`grid ${sidebar && section?.children ? "lg:grid-cols-[260px,1fr] gap-10" : "grid-cols-1"}`}>
          {sidebar && section?.children && (
            <aside className="hidden lg:block">
              <div className="bg-slate-50 rounded-lg overflow-hidden border border-slate-200">
                <div className="bg-[#1c4d9c] text-white px-5 py-3.5 font-semibold text-sm">
                  {section.label}
                </div>
                <ul>
                  {section.children.map((c) => {
                    const active = location.pathname === c.slug;
                    return (
                      <li key={c.slug}>
                        <Link
                          to={c.slug}
                          className={`block px-5 py-3 text-[13.5px] border-b border-slate-200 last:border-b-0 transition flex items-center justify-between gap-2 ${
                            active
                              ? "bg-white text-[#1c4d9c] font-semibold border-l-[3px] border-l-[#1c4d9c]"
                              : "text-slate-700 hover:text-[#1c4d9c] hover:bg-white"
                          }`}
                        >
                          <span>{c.label}</span>
                          <ChevronRight className="w-3.5 h-3.5 opacity-50" />
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </aside>
          )}
          <main className="min-w-0">{children}</main>
        </div>
      </div>
    </div>
  );
};

export default PageShell;
